import React from "react";
import PropTypes from "prop-types";

export default function CompleteMarkSVG(props) {
  const {
    styles: {
      height,
      width,
      fill
    }
  } = props;
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={height || "32px"}
      width={width || "32px"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/Mini/Check">
        <g id="Icon/Action/Check" fill={fill || "#677383"}>
          <path 
            d="M2.30317711,5.75926786 C2.10053888,5.56413026 1.77604806,5.55957038 1.58060606,5.74697407 L0.250086241,7.02277107 C0.0536595003,7.211119 0.0604813455,7.525244 0.255598533,7.71493465 L6.25098029,13.5435745 C6.45045139,13.737498 6.75795695,13.7369661 6.95352403,13.5253895 L15.5530548,4.22188375 C15.7415879,4.01791696 15.7338257,3.69893881 15.537922,3.51153512 L14.2042596,2.23573812 C14.0073689,2.04739019 13.6966316,2.06208875 13.5180568,2.25987553 L6.94185532,9.54357748 C6.75976667,9.74525613 6.45657955,9.75893246 6.24524569,9.55542111 L2.30317711,5.75926786 Z" 
            id="Shape">
          </path>
        </g>
      </g>
    </svg>
  );
}

CompleteMarkSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

CompleteMarkSVG.defaultProps = {
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
